// Frontend enums & UI copy only. Data comes from backend.
export const CATEGORIES = [
  { slug: 'trending', name: 'Trending' },
  { slug: 'movies',   name: 'Movies' },
  { slug: 'series',   name: 'TV Shows' },
  { slug: 'courses',  name: 'Courses' },
  { slug: 'music',    name: 'Music' },
  { slug: 'tech',     name: 'Tech' },
  { slug: 'gaming',   name: 'Gaming' },
  { slug: 'fitness',  name: 'Fitness' },
  { slug: 'news',     name: 'News' },
  { slug: 'live',     name: 'Live' },
];

export const PLANS = [
  { id: 'free',   name: 'Free',        price: 0,  period: '/mo', features: ['Watch free content in HD','Limited library access','Ads before videos','1 active device'], highlight: false },
  { id: 'plus',   name: 'VidCreForge+',     price: 9,  period: '/mo', features: ['Ad-free streaming','Full HD & 4K where available','Unlimited library','2 simultaneous streams','Offline downloads'], highlight: true },
  { id: 'pro',    name: 'Creator Pro', price: 19, period: '/mo', features: ['Everything in VidCreForge+','Unlimited uploads & 10TB hosting','Monetization & memberships','Advanced analytics','Custom channel branding','4 simultaneous streams'], highlight: false },
  { id: 'studio', name: 'Studio',      price: 49, period: '/mo', features: ['Everything in Creator Pro','Team seats (up to 10)','Live streaming & DVR','API access','Priority support'], highlight: false },
];

export const LANDING_FEATURES = [
  { title: 'Upload anything',           desc: 'MP4, MOV or import from YouTube & Vimeo. Unlimited hosting on Creator Pro.' },
  { title: 'Netflix-style storefront',  desc: 'Curated rows, series, and featured hero — your content, your layout.' },
  { title: 'Monetize your audience',    desc: 'Free, Premium, Pay-Per-View or memberships — you pick the model.' },
  { title: 'Live streaming & DVR',      desc: 'Go live from the studio, embed, or OBS. Viewers can catch up anytime.' },
  { title: 'Creator studio & analytics',desc: 'Watch time, retention, revenue — all in one dashboard.' },
  { title: 'Your brand, your rules',    desc: 'Custom colors, logos, domain, subtitles, and localization.' },
  { title: 'Playlists & series',        desc: 'Build multi-episode shows, seasons, and playlists in clicks.' },
  { title: 'Community that stays',      desc: 'Likes, comments, subscribers and watch-next recommendations.' },
  { title: 'Fast global CDN',           desc: 'Adaptive streaming that looks crisp anywhere on any device.' },
];

export const LANDING_FAQ = [
  { q: 'What is VidCreForge?', a: 'VidCreForge is an all-in-one video hosting and streaming platform. Upload, organize, monetize and stream movies, shows, courses, live sessions and more — without managing infrastructure.' },
  { q: 'Can I import from YouTube or Vimeo?', a: 'Yes. Paste a YouTube or Vimeo URL on the Upload page and VidCreForge will embed and organize it alongside your native uploads.' },
  { q: 'How do I monetize?', a: 'Open Studio → Monetization. Set videos as Free, Premium, or Pay-Per-View. You can also offer subscription memberships with tiered benefits.' },
  { q: 'Is there a free plan?', a: 'Yes, the Free plan lets you watch in HD with limited library access. Creators get started with VidCreForge+; Creator Pro unlocks unlimited hosting & monetization.' },
  { q: 'Do you support live streaming?', a: 'Live streaming is available on Studio. Stream from browser or OBS, with automatic DVR for later catch-up viewing.' },
  { q: 'Can I use my own domain and branding?', a: 'Yes — Creator Pro and Studio let you bring your own domain, logo, colors, and custom player branding.' },
];

export function formatCount(n) {
  if (!n && n !== 0) return '0';
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1) + 'M';
  if (n >= 1_000) return (n / 1_000).toFixed(n % 1_000 === 0 ? 0 : 1) + 'K';
  return String(n);
}
